// Mapping da valori enum (machine) a label leggibili (umani) per il payload del webhook.

export const yearsInBusinessLabels: Record<string, string> = {
  under_1: "Meno di 1 anno",
  "1_to_3": "Tra 1 e 3 anni",
  "3_to_7": "Tra 3 e 7 anni",
  over_7: "Oltre 7 anni",
};

export const centerZoneLabels: Record<string, string> = {
  city_center: "Centro città",
  semi_center: "Semicentro",
  suburb: "Periferia",
  small_town: "Paese o piccolo comune",
};

export const clientsLast12MonthsLabels: Record<string, string> = {
  under_200: "Meno di 200",
  "200_500": "Tra 200 e 500",
  "500_1000": "Tra 500 e 1.000",
  "1000_2000": "Tra 1.000 e 2.000",
  over_2000: "Oltre 2.000",
};

export const databaseSizeLabels: Record<string, string> = {
  under_500: "Meno di 500",
  "500_1000": "Tra 500 e 1.000",
  "1000_2000": "Tra 1.000 e 2.000",
  "2000_5000": "Tra 2.000 e 5.000",
  over_5000: "Oltre 5.000",
  paper_only: "Ho solo agenda cartacea",
};

export const salesResponsibleLabels: Record<string, string> = {
  owner: "Titolare",
  dedicated_salesperson: "Persona dedicata alla vendita",
  cabin_operator: "Operatrice in cabina",
  multiple: "Più figure combinate",
};

export const sellsPathsOrCardsLabels: Record<string, string> = {
  paths: "Percorsi",
  cards: "Card",
  both: "Entrambi",
};

export const yesNoLabels: Record<string, string> = {
  yes: "Sì",
  no: "No",
};

export const financingProvidersLabels: Record<string, string> = {
  pagodil: "PagoDil",
  pagolight: "PagoLight",
  klarna: "Klarna",
  scalapay: "Scalapay",
  soisy: "Soisy",
  compass: "Compass",
  other: "Altro",
};

export const hasProprietaryMethodLabels: Record<string, string> = {
  yes: "Ho un mio metodo",
  no: "No - non ho un mio metodo",
};

export const centerSpecializationLabels: Record<string, string> = {
  basic: "Estetica di base (nails/cerette ecc.)",
  face: "Specializzazione Viso",
  body: "Specializzazione Corpo/Dimagrimento",
  advanced: "Estetica avanzata a 360°",
  epilation_laser: "Specializzata in epilazione/laser",
};

export const pricePositioningLabels: Record<string, string> = {
  cheaper: "Sono più economica",
  same: "Ho gli stessi prezzi",
  premium: "Sono più Premium",
};

export const parkingEaseLabels: Record<string, string> = {
  very_easy: "Molto facile",
  easy: "Abbastanza facile",
  neutral: "Neutro",
  difficult: "Abbastanza difficile",
  very_difficult: "Molto difficile",
};

export const socialAdsExperienceLabels: Record<string, string> = {
  yes: "Sì",
  first_time: "No - è la prima volta",
};

export const marketingAgencyExperienceLabels: Record<string, string> = {
  yes: "Sì",
  no: "No - è la prima volta",
};

export const monthlyRevenueLabels: Record<string, string> = {
  under_5k: "Sotto i 5.000€",
  "5k_10k": "Tra 5.000€ e 10.000€",
  "10k_20k": "Tra 10.000€ e 20.000€",
  "20k_40k": "Tra 20.000€ e 40.000€",
  over_40k: "Oltre 40.000€",
};

// Helpers
export const mapLabel = (
  value: string | undefined | null,
  map: Record<string, string>,
): string | null => {
  if (!value) return null;
  return map[value] ?? value;
};

export const mapLabels = (
  values: string[] | undefined | null,
  map: Record<string, string>,
): string[] | null => {
  if (!values || values.length === 0) return null;
  return values.map((v) => map[v] ?? v);
};
